import React, { useEffect, useState } from 'react';
import { UsersRound, ExternalLink, Check, X } from 'lucide-react';
import { getRsvpsApi } from '../../api/cardApi';
import '../../CSS/ProfileRSVPStatus.css';

const ProfileRSVPStatus = ({ uniqueCode }) => {
    const [rsvpData, setRsvpData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!uniqueCode) return;

        const fetchRsvps = async () => {
            try {
                setLoading(true);
                const data = await getRsvpsApi(uniqueCode);
                setRsvpData(data);
            } catch (err) {
                console.error('Failed to load RSVP data:', err);
                setError('Gagal memuatkan data RSVP.');
            } finally {
                setLoading(false);
            }
        };

        fetchRsvps();
    }, [uniqueCode]);

    const hadir = rsvpData?.filter(r => r.attendanceStatus === 'attending').reduce((sum, r) => sum + (r.pax ?? 0), 0) ?? 0;
    const tidakHadir = rsvpData?.filter(r => r.attendanceStatus === 'not_attending').length ?? 0;
    const totalResponses = hadir + tidakHadir;

    return (
        <div className='rsvp-status-container'>
            <div className='rsvp-title'>
                <UsersRound size={18} strokeWidth={2} />
                <h4 className='rsvp-heading'>RSVP Summary</h4>
                <span className='rsvp-total-badge'>
                    {loading ? '...' : `${totalResponses} response`}
                </span>
            </div>

            {loading ? (
                <div className='rsvp-skeleton-row'>
                    <div className='rsvp-skeleton-card' />
                    <div className='rsvp-skeleton-card' />
                </div>
            ) : error ? (
                <p className='rsvp-error'>{error}</p>
            ) : (
                <div className='rsvp-stats-row'>
                    {/* Attending */}
                    <div className='rsvp-stat-card rsvp-stat-hadir'>
                        <span className='rsvp-stat-icon rsvp-icon-hadir'>
                            <Check size={16} strokeWidth={2.5} />
                        </span>
                        <div className='rsvp-stat-info'>
                            <span className='rsvp-stat-count'>{hadir}</span>
                            <span className='rsvp-stat-label'>Attending</span>
                        </div>
                    </div>

                    {/* Not Attending */}
                    <div className='rsvp-stat-card rsvp-stat-tidak'>
                        <span className='rsvp-stat-icon rsvp-icon-tidak'>
                            <X size={16} strokeWidth={2.5} />
                        </span>
                        <div className='rsvp-stat-info'>
                            <span className='rsvp-stat-count'>{tidakHadir}</span>
                            <span className='rsvp-stat-label'>Not Attending</span>
                        </div>
                    </div>
                </div>
            )}

            <div className='rsvp-footer'>
                <a
                    href={`/dashboard/${uniqueCode}`}
                    className='rsvp-dashboard-btn'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <span className='rsvp-dashboard-btn-content'>
                        <ExternalLink size={13} />
                        Dashboard
                    </span>
                </a>
            </div>
        </div>
    );
};

export default ProfileRSVPStatus;
